import type { WabunkaTagDictByGroupName } from '@/models/wabunka/wabunkaTag';

// 体験0件のタグを検索モーダルの選択肢から外す暫定措置。JCAT-6243 で件数判定に置き換え、このファイルごと削除する
const ZERO_RESULT_TAG_WEB_PATHS = ['fukuoka', 'okinawa', 'sumo'];

export const excludeZeroResultTagWebPaths = (webPaths: string[]): string[] => webPaths.filter((webPath) => !ZERO_RESULT_TAG_WEB_PATHS.includes(webPath));

export const excludeZeroResultTags = (tagGroups: WabunkaTagDictByGroupName): WabunkaTagDictByGroupName => {
  const result: WabunkaTagDictByGroupName = {};
  for (const [groupName, tags] of Object.entries(tagGroups)) {
    const remainingTags = tags.filter((tag) => !ZERO_RESULT_TAG_WEB_PATHS.includes(tag.webPath));
    if (remainingTags.length > 0) result[groupName] = remainingTags;
  }
  return result;
};
